import ReactGA from "react-ga4";

export const trackConversion = (label, action = "Click Button") => {
  if (!label || typeof window === "undefined") {
    return;
  }

  try {
    ReactGA.event({
      category: "Conversion",
      action,
      label,
    });
  } catch (error) {
    // Silently ignore tracking errors to avoid blocking UX
    // eslint-disable-next-line no-console
    console.log("GA tracking error", error);
  }
};

export const trackEvent = (category, action, label) => {
  if (!category || !action || typeof window === "undefined") {
    return;
  }

  try {
    ReactGA.event({
      category,
      action,
      label,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("GA tracking error", error);
  }
};
